import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: 'drawdown-chart',
  extends: Line,
  mixins: [reactiveProp],
  data() {
    return {
      options: {
        borderCapStyle: 'butt',
        maintainAspectRatio: false,
        tooltips: {
          mode: 'index',
          callbacks: {
              label: function(tooltipItems, data) {
                return tooltipItems.yLabel.toFixed(2) + " %"
              },
          }
        },
        scales: {
          yAxes: [{
            ticks: {
                userCallback: function(value, index, values) {
                    return value.toString() + '%'
                }
              }
            }]
        },
        legend: {
          display: true
        }
      }
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}